import React, { useEffect, useRef, useState } from "react";
import { Play, X, Maximize2 } from "lucide-react";

const SRC_MP4 = "/video/thoth-demo.mp4";
const SRC_WEBM = "/video/thoth-demo.webm";
const POSTER = "/video/thoth-demo-poster.jpg";
const Sources = () => (<><source src={SRC_MP4} type="video/mp4" /><source src={SRC_WEBM} type="video/webm" /></>);

export default function DemoVideo({ ctaLabel = "Guarda la demo", closeLabel = "Chiudi" }) {
  const [open, setOpen] = useState(false);
  const bigRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => bigRef.current?.play().catch(() => {}), 150);
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; clearTimeout(t); };
  }, [open]);

  return (
    <>
      <div className="relative group" data-testid="hero-demo-video">
        <video poster={POSTER} autoPlay muted loop playsInline preload="metadata"
          className="w-full h-[340px] md:h-[440px] object-cover object-top bg-[#0B0F17]" aria-label="Video dimostrativo di Thoth"><Sources /></video>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17] via-transparent to-transparent pointer-events-none" />
        <button type="button" onClick={() => setOpen(true)} data-testid="hero-demo-play"
          className="absolute inset-x-0 bottom-5 mx-auto w-max inline-flex items-center gap-2 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/15 px-4 py-2 text-sm font-semibold text-white shadow-lg transition-colors">
          <span className="grid place-items-center w-7 h-7 rounded-full bg-blue-600 group-hover:scale-105 transition-transform"><Play className="w-3.5 h-3.5 ml-0.5" fill="currentColor" /></span>
          {ctaLabel}
          <Maximize2 className="w-3.5 h-3.5 text-slate-300" />
        </button>
      </div>

      {open && (
        <div className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4 sm:p-8" onClick={() => setOpen(false)} data-testid="demo-video-modal">
          <button type="button" onClick={() => setOpen(false)} data-testid="demo-video-close" aria-label={closeLabel}
            className="absolute top-4 right-4 inline-flex items-center gap-1.5 rounded-full bg-white/10 hover:bg-white/20 border border-white/15 px-3 py-2 text-sm text-white">
            <X className="w-4 h-4" /> {closeLabel}
          </button>
          <div className="w-full max-w-5xl rounded-2xl overflow-hidden border border-white/10 shadow-2xl shadow-black/60" onClick={(e) => e.stopPropagation()}>
            <video ref={bigRef} poster={POSTER} controls playsInline className="w-full aspect-video bg-black" data-testid="demo-video-player"><Sources /></video>
          </div>
        </div>
      )}
    </>
  );
}
